import { cx } from "./lib/cx.ts";

export interface PillOption<T extends string> {
  value: T;
  label: string;
  /** Hover hint explaining what the option covers. */
  title?: string;
}

/**
 * A single-choice toggle of pills, such as "Mine | All". Rule: exactly one is
 * active and it is shown by a filled pill and medium weight, never an
 * underline or a bar; use it for 2 to 4 short options that re-scope a list.
 * `label` names the group for assistive tech.
 */
export function PillGroup<T extends string>({ label, options, value, onChange, size = "md", class: className }: {
  label: string;
  options: ReadonlyArray<PillOption<T>>;
  value: T;
  onChange: (value: T) => void;
  /** `sm` is a compact chip row (24px) for a control inside a panel; default `md`. */
  size?: "sm" | "md";
  class?: string;
}) {
  return (
    <fieldset aria-label={label} class={cx("ui-pills", size === "sm" && "ui-pills--sm", className)}>
      {options.map((option) => (
        <button key={option.value} type="button" class="ui-pill" aria-pressed={value === option.value} title={option.title} onClick={() => onChange(option.value)}>
          {option.label}
        </button>
      ))}
    </fieldset>
  );
}
